import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs';
import { PmaPermissionsService } from './pma-permissions.service';
import { ApplicationModeService } from '../../application-mode/services/application-mode.service';

@Injectable()
export class PmaPermissionsGuardService  {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    
    const hasPermission =
      (perms: any) => Array.isArray(perms) ? perms.some((value) => this.pmaPermissionsService.hasPermission(value)) : false;

    return this.applicationModeService.isInMyDashboardMode().pipe(
      map((isInDashboardMode) => !isInDashboardMode || hasPermission(route.data.pmaPermissions))
    );

  }

  constructor(private readonly pmaPermissionsService: PmaPermissionsService,
    private readonly applicationModeService: ApplicationModeService) {

  }
}
